/**
 * Whether the epoch has already ended (its end date is in the past).
 */
export function isEpochEnded(epoch: { end: Date } | undefined): boolean {
  return !!epoch && epoch.end.getTime() < Date.now();
}
